module.exports = __webpack_public_path__ + "img/fashion_24.dbb06a21.jpg";